import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";

import Router from "./router/Router";
import ChatBott from "./ChatBott";

import "react-toastify/dist/ReactToastify.css";

import userSocket from "./redux/slices/userSocket";
import { setCredentials } from "./redux/slices/authSlice";

function App() {
    const dispatch = useDispatch();

    const userInfo = useSelector(
        (state) => state.auth?.userInfo
    );

    useEffect(() => {
        // İstifadəçi login olmayıbsa socket qoşulmur
        if (!userInfo?._id) {
            return;
        }

        const userId = userInfo._id;
        const userRoom = `user_${userId}`;

        console.log("USER SOCKET BAŞLADILIR:", userRoom);

        // Socket bağlantısını aç
        userSocket.connect();

        // İstifadəçini öz şəxsi room-una qoş
        userSocket.emit("joinUserRoom", userId);

        // Admin tərəfindən istifadəçi məlumatı dəyişdiriləndə
        // backend bu event-i göndərəcək
        const handleUserUpdated = (updatedUser) => {
            console.log(
                "🔥 USER UPDATED EVENT GƏLDİ:",
                updatedUser
            );

            if (!updatedUser?._id) {
                console.log("❌ updatedUser və ya _id yoxdur");
                return;
            }

            dispatch(setCredentials(updatedUser));

            console.log(
                "✅ Redux + localStorage yeniləndi"
            );
        };

        userSocket.on(
            "userUpdated",
            handleUserUpdated
        );

        // Component dəyişəndə / logout olanda
        // listener-i silirik və socket-i bağlayırıq
        return () => {
            userSocket.off(
                "userUpdated",
                handleUserUpdated
            );

            if (userSocket.connected) {
                userSocket.disconnect();
            }

            console.log(
                "USER SOCKET BAĞLANDI:",
                userRoom
            );
        };
    }, [userInfo?._id, dispatch]);

    return (
        <>
            <Router />

            <ChatBott />

            <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnHover
                draggable
                theme="dark"
            />
        </>
    );
}

export default App;